import Moment from "react-moment";
import i18next from 'i18next';

const MessageDate = ({message, now, directionMine, messageIcon}) => {
    const messageTime = message.ts_in_messenger * 1000;
    const messageDate = message.ts_in_messenger ? new Date(messageTime) : new Date();
    const lang = i18next.language;
    const messageDateHTML = () => {
        if (now.getDate() === messageDate.getDate() && (now - messageDate) < 24 * 60 * 60 * 1000) {
            return <Moment locale={lang} format="HH:mm">{messageTime}</Moment>
        } else {
            return <>
                <Moment locale={lang} format={now.getFullYear() === messageDate.getFullYear() ? "DD MMM" : "DD MMM YYYY"}>
                    {messageTime}
                </Moment>
                &nbsp;&nbsp;
                <Moment locale={lang} format="HH:mm">{messageTime}</Moment>
            </>;
        }
    }

    return <div className="i-chats-dialogue-content-message-note">
        <span className="i-chats-dialogue-content-message-date">
            {messageDateHTML()}
        </span>
        {
            directionMine && messageIcon &&
            <div className="i-chats-dialogue-content-message-check">
                <span>{messageIcon}</span>
            </div>
        }
    </div>
}

export default MessageDate;